import axios from 'axios';
import replaceCartContent from '../cart/replaceCartContent';
import { checkIfAllInstancesOfVariantAddedToCart } from '../cart/updateATCButton';

const forms = document.querySelectorAll('.product-form');

forms.forEach((form) => {
  form.addEventListener('submit', async function (event) {
    event.preventDefault();

    const button = form.querySelector('.add-to-cart-button');
    const spinner = button.querySelector('.add-to-cart-button-spinner');

    if (spinner) spinner.classList.remove('hidden');

    const formData = new FormData(form);
    const productData = {};
    formData.forEach((value, key) => (productData[key] = value));

    const uniqueKey = `key_${Date.now()}`;

    const itemsToAdd = [
      {
        id: productData.id,
        quantity: productData.quantity
      },
    ];

    if (productData.printing_product_quantity) {
      itemsToAdd[0].properties = {
        _main_product_key: uniqueKey
      }
    }

    if (productData.add_on_id && productData.add_on_quantity) {
      itemsToAdd.push({
        id: productData.add_on_id,
        quantity: productData.add_on_quantity,
      });
    }

    if (productData.printing_product_addon_id && productData.printing_product_addon_quantity) {
      itemsToAdd.push({
        id: productData.printing_product_addon_id,
        quantity: productData.printing_product_addon_quantity
      });
    }

    if (productData.printing_product_id && productData.printing_product_quantity && productData.printing_product_text) {
      itemsToAdd.unshift({
        id: productData.printing_product_id,
        quantity: productData.printing_product_quantity,
        properties: {
          printing_text: productData.printing_product_text,
          _main_product_key: uniqueKey
        },
      });
    }

    await addVariantToCart(itemsToAdd);
    await replaceCartContent();

    checkIfAllInstancesOfVariantAddedToCart();

    document.querySelector('[data-component-id="cart-drawer"]').open();
    if (spinner) spinner.classList.add('hidden');
  });
});

async function addVariantToCart(items) {
  try {
    const response = await axios.post('/cart/add.js', {
      items: items.map((item) => {
        const newItem = {
          id: item.id,
          quantity: item.quantity,
        };

        if (item.properties) {
          newItem.properties = item.properties;
        }

        return newItem;
      }),
    });
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function onErrorMsg(errorMessage = false, errorMessageElement) {
  if (!errorMessageElement) return;
  errorMessageElement.toggleAttribute('hidden', !errorMessage);
  if (errorMessage) {
    errorMessageElement.textContent = errorMessage;
    errorMessageElement.classList.remove('hidden');
  }
}

// Function to check if there are multiple variants of the same product in the cart
function checkMultipleVariants() {
  let cartItems = document.querySelectorAll('.single-item-cart');
  let productVariants = {};
  let multipleVariantsExist = false; // Flag to track if multiple variants exist

  // Loop through all cart items
  cartItems.forEach(function (item) {
    let productId = item.getAttribute('data-id');
    let variantId = item.getAttribute('data-variant');

    // If productId already exists in the object, push the variantId into the array
    if (productVariants[productId]) {
      // Only add the variant if it's not already in the list
      if (!productVariants[productId].includes(variantId)) {
        productVariants[productId].push(variantId);
        multipleVariantsExist = true; 
      }
    } else {
      // Create a new entry with this productId and its variant
      productVariants[productId] = [variantId];
    }
  });

  // Show or hide the popup based on the flag
  const popup = document.querySelector('#popup-double-item');
  if (multipleVariantsExist) {
    setTimeout(() => {
      // Show the #popup-double-item element
      document.getElementById('popup-double-item').style.display = 'flex';
      document.getElementById('popup-double-overlay').style.display = 'block';

      function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
    
      const toggleButton = document.getElementById('popup-double-item-toggle');
      const bodyElement = document.getElementById('popup-double-item-body');
    
      toggleButton.addEventListener('click', async function () {
        if (bodyElement.style.maxHeight != '0px') {
          bodyElement.style.maxHeight = '0px';
          bodyElement.style.overflow = 'hidden';
          toggleButton.style.transform = 'rotate(180deg)';
          await delay(500);
          document.getElementById('popup-double-overlay').style.display = 'none';
        } else {
          bodyElement.style.maxHeight = '1000px';
          bodyElement.style.overflow = 'visible';
          toggleButton.style.transform = 'rotate(0deg)';
          document.getElementById('popup-double-overlay').style.display = 'block';
        }
      });
    }, 1500);
  }
}

document.addEventListener('DOMContentLoaded', function () {

  checkMultipleVariants();

  const cartDrawer = document.querySelector('#cart-drawer');
  
  if (cartDrawer) {
    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          checkMultipleVariants();
        }
      }
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

});